/**
 * メンテナンスモードフラグ
 * trueにすると、ログイン済みユーザーにも未ログイン状態のUIを表示し、
 * 「ログイン中です」というモーダルを表示する
 */
export const IS_MAINTENANCE_MODE = false;
